import Text from 'antd/lib/typography/Text'
import dayjs from 'dayjs'
import { Flex } from 'antd'

import { Ticket, StatusTicketEnum } from '@types'

import { useHandleTicketModal } from '../../../../../../../contexts/HandleTicketModalContext'
import { CardRow, StyledRequestCard } from '../../..'
import CardIndicator from '../CardIndicator'

interface RequestCardProps {
  data: Ticket
}

const RequestCard = (props: RequestCardProps) => {
  const { data } = props
  const { CANCELED, NO_SHOW } = StatusTicketEnum
  const { setTicketToEdit, setIsTicketModalOpen } = useHandleTicketModal()

  return (
    <StyledRequestCard
      onClick={e => {
        const { tagName } = e.target as HTMLInputElement
        if (tagName !== 'INPUT') {
          setTicketToEdit(data.id)
          setIsTicketModalOpen(true)
        }
      }}
      style={{ backgroundColor: `#${data.equipment?.color}` }}
      className={`${data.status.name === CANCELED && 'canceled'} ${
        data.status.name === NO_SHOW && 'no-show'
      }`}
    >
      <CardRow className="card__header">
        <Text className="card__withdrawal-info">
          {`${dayjs(data.withdrawalDate).format('H:mm')} | #${data.id}`}
        </Text>
        <CardIndicator
          dateCreated={data.createAt}
          status={data.status.name}
          date={data.pendingDate || undefined}
          withdrawalDate={data.withdrawalDate}
        />
      </CardRow>
      <CardRow className="card__content">
        <Flex vertical className="item">
          <Text>De:</Text>
        </Flex>
        <Flex>{data.origin?.tag && <Text>{data.origin.tag}</Text>}</Flex>
      </CardRow>
      <CardRow className="card__content">
        <Flex vertical className="item">
          <Text>A:</Text>
        </Flex>
        <Flex>{data.destination?.tag && <Text>{data.destination.tag}</Text>}</Flex>
      </CardRow>
      {data.material?.nameShort && (
        <CardRow className="card__content">
          <Text className="scrap-green">Mat: {data.material.nameShort}</Text>
        </CardRow>
      )}
      {data.equipment?.nameShort && (
        <CardRow className="card__content">
          <Text>
            Eq: {data.carrier && <u>&ldquo;{data.carrier.businessName}&ldquo;</u>}{' '}
            {data.equipment.nameShort}
          </Text>
        </CardRow>
      )}
    </StyledRequestCard>
  )
}

export default RequestCard
